import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormRadioButtons, FormToggle, getFieldName, TickerPicker, VerticalLayout } from 'widgets';

export const ComplianceRequirements = ({ prefix }: { prefix?: string }) => {
    const { watch, setValue } = useFormContext();
    const section13d = watch(getFieldName('section13d', prefix));
    const section16 = watch(getFieldName('section16', prefix));

    useEffect(() => {
        if (section13d === 'no') {
            setValue(getFieldName('section13DNdvrAssetIdList', prefix), []);
        }
    }, [prefix, section13d, setValue]);

    useEffect(() => {
        if (section16 === 'no') {
            setValue(getFieldName('section16NdvrAssetIdList', prefix), []);
        }
    }, [prefix, section16, setValue]);

    return (
        <VerticalLayout $gap={32}>
            <VerticalLayout $gap={16}>
                <FormRadioButtons
                    horizontal
                    name={getFieldName('section13d', prefix)}
                    title="Section 13D"
                    subtitle="Is a 5% or more shareholder of a public company?"
                    values={[
                        { label: 'Yes', value: 'yes' },
                        { label: 'No', value: 'no' },
                    ]}
                />
                {section13d === 'yes' && (
                    <TickerPicker name={getFieldName('section13DNdvrAssetIdList', prefix)} label="Company symbol(s)*" />
                )}
            </VerticalLayout>

            <VerticalLayout $gap={8}>
                <FormRadioButtons
                    horizontal
                    name={getFieldName('section16', prefix)}
                    title="Section 16"
                    subtitle="Is a director, officer, or principle shareholder of a public company?"
                    values={[
                        { label: 'Yes', value: 'yes' },
                        { label: 'No', value: 'no' },
                    ]}
                />
                {section16 === 'yes' && (
                    <TickerPicker name={getFieldName('section16NdvrAssetIdList', prefix)} label="Company symbol(s)*" />
                )}
            </VerticalLayout>

            <FormToggle name={getFieldName('unusualActivity', prefix)} label="Unusual Activity" />
        </VerticalLayout>
    );
};
